<template>
  <Layout class="fz-shell">
    <Sider
      hide-trigger
      collapsible
      :collapsed-width="88"
      v-model="collapsed"
      width="200"
      class="fz-shell__sider"
    >
      <div class="fz-brand">
        <img src="@/assets/image/fzblack.png" alt="FZMetrics" />
        <div v-show="!collapsed" class="fz-brand__meta">
          <div class="fz-brand__name">FZMetrics</div>
        </div>
      </div>

      <Menu
        theme="dark"
        :width="collapsed ? '80px' : '200px'"
        :active-name="$route.name"
        class="fz-shell__menu"
        :collapsed="collapsed"
      >
        <MenuItem v-for="item in menuItems" :key="item.name" :name="item.name" @click="go(item.path)">
          <Icon :type="item.icon" />
          <span v-show="!collapsed">{{ item.label }}</span>
        </MenuItem>
      </Menu>
    </Sider>

    <Layout>
      <Header class="fz-shell__header">
        <div class="fz-shell__header-left">
          <Icon :type="collapsed ? 'md-menu' : 'md-menu'" size="22" @click="collapsed = !collapsed" />
          <div class="fz-shell__title">{{ currentTitle }}</div>
        </div>
        <div class="fz-shell__header-right">
          <Tag color="cyan">{{ serverAddress }}</Tag>
          <Button size="small" icon="md-log-out" @click="logout">退出</Button>
        </div>
      </Header>

      <Content class="fz-shell__content">
        <router-view />
      </Content>
    </Layout>
  </Layout>
</template>

<script>
export default {
  name: 'AppShell',
  data() {
    return {
      collapsed: false,
      menuItems: [
        { name: 'platforms', label: '平台配置', path: '/platforms', icon: 'ios-link' },
        { name: 'devices', label: '设备查询', path: '/devices', icon: 'ios-list-box' },
        { name: 'flow-analysis', label: '跑量分析', path: '/flow-analysis', icon: 'ios-trending-up' },
        { name: 'dashboard-data', label: '大盘数据', path: '/dashboard-data', icon: 'ios-stats' },
        { name: 'charts', label: '图表绘制', path: '/charts', icon: 'ios-pulse' },
        { name: 'advanced-charts', label: '高级图表', path: '/advanced-charts', icon: 'ios-analytics' },
        { name: 'audit', label: '接口审计', path: '/audit', icon: 'ios-key' },
        { name: 'manual-draw', label: '手动绘图', path: '/manual-draw', icon: 'ios-create' },
        { name: 'compare', label: '数据对比', path: '/compare', icon: 'ios-stats' },
      ],
    }
  },
  computed: {
    currentTitle() {
      return this.$route.meta.title || 'FZMetrics'
    },
    serverAddress() {
      return (process.env.VUE_APP_BASE_URL || '/').replace(/\/$/, '')
    },
  },
  methods: {
    go(path) {
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },
    logout() {
      localStorage.removeItem('fzmetrics_login_token')
      localStorage.removeItem('userinfo')
      this.$router.replace('/login')
    },
  },
}
</script>

<style scoped>
.fz-shell {
  min-height: 100vh;
  background: #f0f2f5;
}

.fz-shell__sider {
  background: #001529 !important;
}

.fz-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 30px 0 15px;
}

.fz-brand img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  padding: 6px;
}

.fz-brand__name {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.fz-shell__menu {
  background: #001529 !important;
}

.fz-shell__menu.ivu-menu-vertical .ivu-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  font-size: 16px;
  padding: 15px 0;
  width: 100%;
  text-align: center;
}

.fz-shell__menu:not(.ivu-menu-vertical-collapsed) .ivu-menu-item {
  padding: 15px 30px;
  justify-content: flex-start;
}

.fz-shell__menu :deep(.ivu-menu-item:hover) {
  color: #bfe1ff;
}

.fz-shell__menu :deep(.ivu-menu-item-selected) {
  color: #bfe1ff !important;
  background: #0081ff !important;
}

.fz-shell__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 65px;
  padding: 0 20px;
  background: #fff;
  box-shadow: 0 2px 2px #00000010;
}

.fz-shell__header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.fz-shell__title {
  color: #1f2d3d;
  font-size: 18px;
  font-weight: 700;
}

.fz-shell__content {
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f4f4f4;
}
</style>
